import { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import { useAuth } from '@neotech-solutions-org/neofusion-fe-shared';
import useDisplayContentConfig from './useDisplayContentConfig';
import useAuthForms from './useAuthForms';
import { useRemoveSearchParam } from './useRemoveSearchParam';

export const useVerifyEmailRedirect = () => {
  const { isAuthenticated } = useAuth();
  const { isEndUserMode } = useDisplayContentConfig();
  const [searchParams] = useSearchParams();
  const { openLoginForm } = useAuthForms();
  const removeParam = useRemoveSearchParam();

  const loginRedirect = searchParams.get('loginRedirect');

  useEffect(() => {
    if (!isAuthenticated && isEndUserMode && loginRedirect) {
      openLoginForm();
      removeParam('loginRedirect');
    }
  }, [openLoginForm, isAuthenticated, loginRedirect, isEndUserMode, removeParam]);
};
